import {connect} from "react-redux"
import State from "../../ducks/state"
import {REALM_HEADER, TERRITORY_HEADER, LANGUAGE_HEADER} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const {headers, url} = state.request
    const {contentBannerCmsPath, enableContentBanner, coreMediaAuthTokenName, coreMediaAuthTokenValue} = state.settings

    const trimmedUrl = (url && (url[0] === "/" ? url.substring(1) : url)) || ""

    const isExcluded =
        (new URLSearchParams(trimmedUrl).get("excludeContentBanner")?.toLocaleLowerCase() || "") === "true"

    return {
        realm: headers?.[REALM_HEADER] as string,
        territory: headers?.[TERRITORY_HEADER] as string,
        language: headers?.[LANGUAGE_HEADER] as string,
        contentBannerCmsPath,
        coreMediaAuthTokenName,
        coreMediaAuthTokenValue,
        isExcluded,
        enableContentBanner,
        templating: state.template,
    }
}

export default connect(mapStateToProps)
